import { useNextRouter } from '@/data/Content/_NextRouter';
import { useApplyBankPromotionInAuth } from '@/data/Content/BanksPromotion';
import { useUser } from '@/data/User';
import { useEffect } from 'react';

type RFC = React.FC<React.PropsWithChildren<{}>>;

export const AutoApplyBankPromotion: RFC = ({ children }) => {
	const { onApplyBankPromotionInAuth } = useApplyBankPromotionInAuth();
	const { user } = useUser();
	const router = useNextRouter();

	useEffect(() => {
		if (user?.isLoggedIn) {
			const applyPromotion = async () => {
				const result = await onApplyBankPromotionInAuth();
				if (result.redirect) {
					router.push(result.redirect);
				}
			};

			applyPromotion();
		}
	}, [onApplyBankPromotionInAuth, router, user]);

	return <>{children}</>;
};
